export default function (state, val) {
    state.page = 1;
    state.loading = false;
    val.Items.forEach(i => {
        i.value = i.Id;
        i.label = i.Name;
        i.type = 0;
        i.typeColor = '';
        if (i.ActualPaymentSum === 0) {
            i.type = 1;
            i.typeTitle = 'Нет оплаты';
        }
        if (i.ActualPaymentSum && i.Sum > i.ActualPaymentSum) {
            i.type = 2;
            i.typeTitle = 'Частичная оплата';
        }
        if (i.Sum === i.ActualPaymentSum) {
            i.type = 3;
            i.typeTitle = 'Полная оплата';
        }
        if (i.Sum < i.ActualPaymentSum) {
            i.type = 4;
            i.typeTitle = 'Переплата';
        }
    });
    state.items = val.Items;
}